import { Button, withStyles } from '@material-ui/core';

const GreenButton = withStyles({
  root: {
    minWidth: '30px',
    color: 'white',
    padding: '0px 10px',
    margin: 5,
    borderRadius: 20,
    fontSize: '1.3rem',
    background: '#5AA600',
    '&:hover': {
      background: '#69c200',
    },
    '&:active': {
      background: '#69c200',
    },
  },
  disabled: {
    background: '#C4C4C4',
  },
})(Button);

export default GreenButton;
